export default __webpack_public_path__ + "static/media/ms.762e6fde.svg";